export const QueueSection = ({ emoji, title, subtitle, items, empty, render, testId, cols = 'xl:grid-cols-2' }) => (
  <section className="space-y-3" data-testid={testId}>
    <div>
      <h2 className="font-jakarta text-lg font-bold text-[#2D2623] flex items-center gap-2">
        <span className="text-xl" aria-hidden>{emoji}</span>
        {title}
        <span className="text-[11px] font-bold bg-[#2D2623] text-white rounded-full px-2 py-0.5" data-testid={testId && `${testId}-count`}>{items.length}</span>
      </h2>
      {subtitle && <p className="text-xs text-[#9A8E85] mt-0.5">{subtitle}</p>}
    </div>
    {items.length === 0 ? (
      <div className="rounded-3xl border-2 border-dashed border-[#E8E1D5] bg-white/50 px-6 py-8 text-center text-sm text-[#9A8E85]" data-testid={testId && `${testId}-empty`}>
        {empty}
      </div>
    ) : (
      <div className={`grid grid-cols-1 ${cols} gap-3`}>{items.map((it, i) => render(it, i))}</div>
    )}
  </section>
);

export const StatTile = ({ emoji, value, label, tone = '', testId }) => (
  <div className={`wf-card wf-rise p-4 ${tone}`} data-testid={testId}>
    <div className="text-2xl" aria-hidden>{emoji}</div>
    <div className="text-2xl font-extrabold text-[#2D2623] mt-1" data-testid={testId && `${testId}-value`}>{value}</div>
    <div className="text-[11px] uppercase tracking-wider font-semibold text-[#9A8E85]">{label}</div>
  </div>
);
